const Form068TC = {
    formFirstLine:
        "有關資助中學或特殊學校高於核准職級的校長／降職晉升職級教師／降職一級實驗室技術員",
    formSecondLine: "{{schoolYear}}學年特別支薪安排申請",
    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0105": "請輸入一個有效的英文姓名",
        "E-0104": "請輸入一個有效的中文姓名",
        "E-0103": "請輸入0-49的範圍",
        "E-0102": "請輸入0-49的範圍",
        "E-0101": "請輸入正確數字",
        "E-0100": "請輸入14-41的範圍",
        "E-0099": "請輸入0-49的範圍",
        "E-0107": "降職／晉升前後的職級不能相同",
        "E-0108": "請選擇8月1日與9月30日之間的日期",
        "E-0109": "降職／晉升前後的增薪日期不能相同",
        "E-0110": "只允许输入 0 - 49",
        "E-0111": "只允许输入 0 - 49",
        "E-0112": "只允许输入 0 - 49",
        schoolYear:
            "請輸入一個有效的建議學年(20XX/XX)，而該學年不應是本學年或之前",
        firstSchoolYearError:
            "請輸入一個有效的建議學年(20XX/XX)，而該學年不應是本學年或之後",
        reason: "請輸入一個有效的註明",
        firstSchoolYear: "請輸入一個有效的學年",
    },

    stepName: {
        ImportantNotes: "重要事項",
        action: "行動",
        note: "註意",
        information: "基本資料",
        payPointForOverRankedStaff: "高於核准職級的教職員的支薪點",
        certification: "聲明",
        confirmation: "確認",
    },
    businessTypes: {},
    label: {
        ImportantNotes: "個人資料收集聲明",
        ImportantNotesContent: {
            // title: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
            // a: "辦理與聘用有關的事宜；",
            // b: "處理發放薪金津貼及其他政府資助；",
            // c: "計算公積金的供款；",
            // d: "進行核數工作；",
            // e: "進行研究及統計資料，以便規劃教育服務；",
            // f: "處理有關教育專業人員發展的事宜；",
            // g: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
            // title1: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
            // title2: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
            // title3: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
            // title4: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
            title: "個人資料收集聲明",
            p_title: "收集個人資料的目的",
            p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
            p1_a: "處理、核實及查證就資助學校高於核准職級的校長／降職教師或實驗室技術員作特別支薪安排的申請；",
            p1_b: "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            p1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            p1_d: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            p1_e: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
            p1_f: "編製統計資料、研究及政府刊物；以及",
            p1_g: "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》]。",

            p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關申請。",

            p_title3: "可獲轉移資料者",
            p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
            p3_a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
            p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
            p3_c: "你曾就披露個人資料給予訂明同意；以及",
            p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

            p_title4: "查閱個人資料",
            p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向有關高級學校發展主任提出，並寄交教育局網頁(<a href='https://www.edb.gov.hk/tc/contact-us/reo.html' target='_blank'>https://www.edb.gov.hk/tc/contact-us/reo.html</a>)所載區域教育服務處地址或電郵至 <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>。",
        },
        csdoBeforeText: "致﹕教育局總學校發展主任",
        csdoAfterText: "",
        applicationForm: "基本資料",
        note: "註意",
        schoolChoice: {
            ManagementCommittee: "校董會",
            Incorporated: "法團校董會",
        },

        conditionCheck: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        iamsmart: "本人明白需透過「智方便+」帳戶以辧理申請。",

        ActionToBeTakenList: {
            one: "調配高於核准職級的教職員，以填補同一學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            two: "調配高於核准職級的教職員，以填補同一學校內因_________而新設的對等職級職位。",
            three: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            four: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因________而新設的對等職級職位。",
            five: "高於核准職級的教職員將會參加共享職位。",
            six: "高於核准職級的教職員將會退休／辭職。",
            seven: "其他措施",
            // eight: "其他措施",
            // nine: "其他措施",
        },
        ActionToBeTakenList1: {
            one: "調配高於核准職級的教職員，以填補同一學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            two: "調配高於核准職級的教職員，以填補同一學校內因<u>{{desc}}</u>而新設的對等職級職位。",
            three: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            four: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因<u>{{desc}}</u>而新設的對等職級職位。",
            five: "高於核准職級的教職員將會參加共享職位。",
            six: "高於核准職級的教職員將會退休／辭職。",
            seven: "其他措施：<u>{{desc}}</u>",
            // eight: "其他措施：<u>{{desc}}</u>",
            // nine: "其他措施：<u>{{desc}}</u>",
        },
        ActionToBeTakenList2: { ten: "不適用" },

        IncrementalDateList: {
            none: " ",
            jan: "01",
            feb: "02",
            mar: "03",
            apr: "04",
            may: "05",
            jun: "06",
            jul: "07",
            aug: "08",
            sep: "09",
            oct: "10",
            nov: "11",
            dec: "12",
        },
        conditions: "本人已閱讀、理解及同意上述條款及細則",
        noteList: {
            note1: "1：請適當刪除。",
            note2: "2：薪級點不超過職級最高薪級點的離職員工，可按職級的薪級進行。",
            note3: "3：不包括責任津貼（如有）",
            note4:
                "4：涉及基本職等以上一級教師（如PGM）而下一級教師沒有空缺時，有關學校有權決定是否留用+" +
                "老師降職超過一個級別，或有一系列降職涉及到不止一個老師，直到 " +
                "這個權利沒有被超越。做出的決定應該有充分的理由支持。上訴" +
                "機製也應該到位。所有這些都應該讓學校的老師知道，並適當地" +
                "作為對可能出現的任何不公平或不正當指控的保障。",
            note5: "5：不再合資格領取以前可享有的責任津貼(如有)，因此，責任津貼不包括在內。",
            note6: "6：只適用於支薪點尚未超越降職後所屬職級頂薪點的教職員。如非前述情況，應標示為“不適用”，降職教職員僅在貴校回復至降職前的職級後，才會按原來職級的薪級表獲發增薪點。",
            note7: "7：請參閱所附附件並填寫代碼編號。",
            note8: "8：如果該學年不是2022／23學年，學校還應附加一個計劃關於如何糾正的情況，列出預期的空置情況推廣躋身在同樣的學校贊助機構（如適用）在未來學校年。",

            // note0: "我確認：",
            // notea: "（一） EDBCM第46／2021號規定的富余人員選拔安排已被遵守;",
            // noteb:
            //     "（二）學校內或同級學校沒有有關職級的空缺" +
            //     "2021／22學年重新部署的贊助機構。各自的空缺情況" +
            //     "學校內及同一贊助機構下的學校之間的晉升等級（如果 " +
            //     "適用）連接",
            // notec: "（三）已將上述特別及臨時安排通知離職人員;",
            // noted: "（四）本表格內的資料包括修正計劃均屬正確;",
            // notee: "（五）離職員工在2021／22學年的職責將盡可能與其工資相稱;和",
            // notef: "（六）學校須將多繳的薪金補助金退還教育局。",
        },
        rankList: {
            LTIII: "LTIII",
            LTII: "LTII",
            LTI: "LTI",
            CM: "CM",
            AM: "AM",
            SAM: "SAM",
            PAM: "PAM",
            GM: "GM",
            SGM: "SGM",
            PGM: "PGM",
            PII: "PII",
            PI: "PI",
        },
    },
    information: {
        CSDO: "總學校發展主任",
        schoolName: "學校名稱",
        schoolCode: "學校編號",
        Date: "日期",
        ManagementCommittee: "校董會／法團校董會",
        HKIDNo: "香港身份證號碼",
        formHeaderTitle: "職員{{index}}",
        code: "編號",
        EnglishName: "英文姓名",
        ChineseName: "中文姓名",
        pleaseSpecify: "請註明",
        firstSchoolYear:
            "如{{year}}年8月31日或之前已降職，填上<u><b>首次</b></u>獲批特別支薪安排的學年",
        Ranks: "職級",
        Salary: "薪金（總薪級表薪點）",
        //SalaryBar: "薪酬關限",
        MaxSalary: "頂薪點（總薪級表薪點）",
        IncrementalDate: "增薪日期（01/月份）",
        EffectiveDateFrom: "生效日期由",
        EffectiveDateTo: "生效日期至",

        Rank: "職級",
        Salary3: "薪金（總薪級表薪點）",
        //SalaryBars: "薪酬關限",
        MaxSalarys: "頂薪點（總薪級表薪點）",
        IncrementalDates: "增薪日期（01/月份）",
        DateOfNextIncrement: "下次增薪日期",
        // ActionToBeTaken: "措施",
        // ActionToBeTaken: "在{{schoolyear}}學年及其後學年將會採取的措施",
        ActionToBeTaken: "於{{schoolYearNext}}學年採用的措施",
        // ProposedSchoolYear: "建議學年",
        ProposedSchoolYear:
            "如非{{schoolYearNext}}學年修正，請填上預期修正的學年",
        attachment: "補充文件",
        formConfirm: "本人確認：",
        attachment1: "附件",
        Notes1: "在{{year}}年8月31日當日",
        EffectiveDateFromBeforeText: "由",
        EffectiveDateFromAfterText: "至",
        EffectiveDateToAfterText: "降職後生效（如有需要，請修改上述期間）。",
        // Notes2: "由{{from}}至{{to}}降職後生效（如有需要，請修改上述期間）。",
        Notes2: "由{{from}}至{{to}}",
        Notes4: "降職後生效",
        Notes3: "修正計劃",
        // Notes3: "修正高於核准職級情況的計劃",

        beforeDateText: "教育局",
        afterDateText: "的來信已經收到。本校",
        beforeNote1Text:
            "為下列高於核准職級的教職員（包括{{year}}年9月1日前高於核准職級的校長，降職晉升職級教師及／或降職一級實驗室技術員），向教育局申請在{{schoolyear}}學年保留其在{{year}}年8月31日的",
        afterNote1Text: "",
        noteLabel1: "",
        noteLabel2: "支薪點",
        afterNote2Text: "。",
    },
    monthOptions: {
        aug: "8月",
        sept: "9月",
    },
    SalaryList: {
        25: "51,095",
        26: "53,500",
        27: "55,995",
        28: "58,635",
        29: "61,415",
        30: "64,270",
        31: "67,295",
        32: "70,465",
        33: "73,775",
        34: "74,515",
        35: "75,265",
        36: "78,385",
        37: "82,105",
        38: "85,870",
        39: "89,845",
        40: "93,710",
        41: "97,745",
    },
    CSDOValue: {
        0: "北區",
        1: "葵青區",
        2: "西貢區",
        3: "東區",
        4: "屯門區",
        5: "九龍城區",
        6: "觀塘區",
        7: "南區",
        8: "油尖旺區",
        9: "荃灣區",
        10: "沙田區",
        11: "深水埗區",
        12: "大埔區",
        13: "灣仔區",
        14: "離島區",
        15: "中西區",
        16: "元朗區",
        17: "黃大仙區",
    },
    // confirmStatementList: {
    //     statement1:
    //         "（a）已參照教育局通函第46／2020號所載有關揀選過剩教職員的安排；",
    //     statement2:
    //         "（b）辦學團體其他轄下學校於2020／21學年沒有可供調配的合適職級的空缺，並夾附本校及辦學團體屬校的相關晉升職級空缺情況（如適用）；",
    //     statement3: "（c）已通知降職教職員有關上述",
    //     statement3BoldAUnderlineText: "特殊的臨時安排",
    //     statement3AfterBoldAUnderlineText: "；",
    //     statement4: "（d）本表格內所載的資料包括修正計劃均屬正確無誤；",
    //     statement5:
    //         "（e）須降職的教職員在2020／21學年的職務，會盡量與其薪酬相稱；以及",
    //     statement6: "（f）本校會把任何多付的薪金津貼退還教育局。",
    // },
    notes: {
        a: "已參照教育局{{circularNumber}}所載有關揀選過剩教職員的安排；",
        b: "辦學團體其他轄下學校於{{schoolyear}}學年沒有可供調配的合適職級的空缺，並夾附本校及辦學團體屬校的相關晉升職級空缺情況（如適用）；",
        c: "已通知降職教職員有關上述<u><b>特殊的臨時安排</b></u>；",
        d: "本表格內所載的資料包括修正計劃均屬正確無誤；",
        e: "須降職的教職員在{{schoolyear}}學年的職務，會盡量與其薪酬相稱；以及",
        f: "本校會把任何多付的薪金津貼退還教育局。",
    },

    // confirmStatementList: {
    //     a: "已參照教育局通函{{circularNumber}}所載有關揀選過剩教職員的安排；",
    //     b: "辦學團體其他轄下學校於{{schoolYear}}學年沒有可供調配的合適職級的空缺，並夾附本校及辦學團體屬校的相關晉升職級空缺情況（如適用）；",
    // },
    // confirmStatementList2: {
    //     c: "已通知降職教職員有關上述",
    //     cBoldAUnderlineText: "特殊的臨時安排",
    //     cAfterBoldAUnderlineText: "；",
    // },

    // confirmStatementList3: {
    //     d: "本表格內所載的資料包括修正計劃均屬正確無誤；",
    //     e: "須降職的教職員在{{schoolYear}}學年的職務，會盡量與其薪酬相稱；以及",
    //     f: "本校會把任何多付的薪金津貼退還教育局。",
    // },
    tooltipList: {
        tooltip1: "請刪去不適用者。",
        tooltip2:
            "降職教職員的支薪點如尚未達到降職後所屬職級的頂薪點，可按照降職後所屬職級的薪級表繼續增薪。",
        tooltip3:
            "只適用曾獲批特別支薪安排的教職員。如相關教職員於{{schoolyear}}學年降職並首次申請特別支薪安排，應填上“不適用”。",
        tooltip4: "不包括責任津貼（如有）。",
        tooltip5:
            "如須降職的晉升職級教師的職級超出基本職級<u>多於一級</u>（例如首席學位教師），而學校並無職位空缺讓該晉升職級教師只降低一級，則學校有酌情權，決定是否把該晉升職級教師降職多於一級，或安排多於一位晉升職級教師進行一連串降職，直到不超出核准編制為止。學校必須有充分理據支持所作的決定，亦應設立上訴機制。有關的安排應讓校內全體教師知悉，並妥為記錄，以便日後如被指處事不公平或不適當，可作證明之用。",
        tooltip6:
            "不再合資格領取以前可享有的責任津貼（如有），因此，責任津貼不包括在內。",
        tooltip7:
            "只適用於支薪點尚未超越降職後所屬職級頂薪點的教職員。如非前述情況，應填上“不適用”，降職教職員僅在貴校回復至降職前的職級後，才會按原來職級的薪級表獲發增薪點。",
        tooltip8:
            "（如預期修正的學年非{{schoolYearNext}}學年，應填上“不適用”。）",
        tooltip9:
            "（如預期修正的學年非{{schoolYearNext}}學年，學校需另行提交文件詳細說明修正高於核准職級情況的計劃及所屬辦學團體其他屬校於未來學年預計於各晉升職級出現的空缺（如適用）的詳情。）",
        tooltip10: "薪金（總薪級表薪點）不應大於頂薪點（總薪級表薪點）",
        tooltip11: "提議的學年不應是上一學年",
    },
};
export default Form068TC;
